import PropTypes from 'prop-types'
import styled from 'styled-components'

export const StyledFlexWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.gap || '0px'}
`

const FlexWrapper = ({ children, margin, gap }) => {
  return (
    <StyledFlexWrapper gap={gap || margin}>
      {children}
    </StyledFlexWrapper>
  )
}

FlexWrapper.propTypes = {
  margin: PropTypes.string,
  children: PropTypes.node,
  gap: PropTypes.string,
}

export default FlexWrapper
